// IMPORTANT: any changes in this file must be reflected as well in od-commerce/hybris/bin/custom/od/odlegacystoreaddon/acceleratoraddon/web/webroot/_ui-src/common/javascript/app/core/enhancedChatSetup.js

import { isMobileDevice, getAttributeValue } from '../../utils/utils';

const dataId = '#enhancedChatSetup';
const url = getAttributeValue(dataId, 'data-connection-url') || '';

const setupData = {
	connectionUrl: url,
	scriptSrc: url ? `${url}/assets/js/bootstrap.min.js` : '',
	organizationId: getAttributeValue(dataId, 'data-organization-id') || '',
	deploymentId: getAttributeValue(dataId, 'data-deployment-id') || '',
	scrtUrl: getAttributeValue(dataId, 'data-scrt-url') || '',
	country: getAttributeValue(dataId, 'data-country') || '',
	language: getAttributeValue(dataId, 'data-language') || '',
	guid: window?.dataLayer?.[0]?.userInfo?.customerGUID || '',
	userLanguageCode: getAttributeValue(dataId, 'data-language-code') || '',
	firstName: getAttributeValue(dataId, 'data-first-name') || '',
	lastName: getAttributeValue(dataId, 'data-last-name') || '',
	email: getAttributeValue(dataId, 'data-email') || '',
	customerID: window?.dataLayer?.[0]?.userInfo?.customerID || '',
};

const createScript = () => {
	const script = document.createElement('script');
	script.src = setupData.scriptSrc;
	script.onload = function () {
		initEmbeddedMessaging();
	};
	document.body.appendChild(script);
};

const initEmbeddedMessaging = () => {
	try {
		window.embeddedservice_bootstrap.settings.language =
			setupData.userLanguageCode;

		window.embeddedservice_bootstrap?.init(
			setupData.organizationId,
			setupData.deploymentId,
			setupData.connectionUrl,
			{
				scrt2URL: setupData.scrtUrl,
			},
		);
	} catch (e) {
		// eslint-disable-next-line no-console
		console.error('Error initializing Embedded Messaging:', e);
	}
};

const handleOnEmbeddedMessagingReady = () => {
	window.addEventListener('onEmbeddedMessagingReady', () => {
		const chatEntry = document.querySelector('[data-id="enhancedChat"]');
		const isLoggedIn = Boolean(setupData?.guid);

		// Hidden pre-chat fields
		window.embeddedservice_bootstrap?.prechatAPI?.setHiddenPrechatFields({
			GUID: setupData.guid,
			Language: setupData.language,
			Country: setupData.country,
		});

		if (isLoggedIn) {
			// Visible pre-chat fields
			window.embeddedservice_bootstrap?.prechatAPI?.setVisiblePrechatFields({
				_firstName: { value: setupData.firstName, isEditableByEndUser: true },
				_lastName: { value: setupData.lastName, isEditableByEndUser: true },
				_email: { value: setupData.email, isEditableByEndUser: true },
				'Customer Number': {
					value: setupData.customerID,
					isEditableByEndUser: false,
				},
			});
		}

		chatEntry?.addEventListener('click', () =>
			window.embeddedservice_bootstrap?.utilAPI?.launchChat(),
		);
	});
};

const toggleHeaderClass = () => {
	const header = document?.querySelector('.page__header');
	header?.classList?.toggle('page__header--is-inactive');
};

const toggleOnEvent = eventTypes => {
	eventTypes?.forEach(eventType =>
		window?.addEventListener(eventType, () => toggleHeaderClass()),
	);
};

const enhancedChatSetup = () => {
	const isMobile = isMobileDevice();

	createScript();
	handleOnEmbeddedMessagingReady();

	if (isMobile) {
		const eventTypes = [
			'onEmbeddedMessagingWindowClosed',
			'onEmbeddedMessagingWindowMinimized',
			'onEmbeddedMessagingWindowMaximized',
		];
		toggleOnEvent(eventTypes);
	}
};

export { enhancedChatSetup, setupData };
